import { CurrencySymbol } from '@/constants/enums';

export const toCurrencySymbol = (value?: string): CurrencySymbol => {
  if (!value) return CurrencySymbol.USD;
  const currency = value.toUpperCase();
  return CurrencySymbol[currency] || currency;
};
